import { SET_AUTH, SET_CALL_BACK_PARAM, SET_TRANSACTION_ID, SET_USER_INFO } from './mutations';
import router from '@/router/index';
import routeName from '@/router/constant.js';
import { getLogout } from '@/apis/login.js';

export const actions = {
    setAuth({ commit }, payload) {
        commit(SET_AUTH, payload);
    },
    setUserInfo({ commit }, payload) {
        commit(SET_USER_INFO, payload);
    },
    setTransactionId({ commit }, payload) {
        if (!payload) {
            payload = '';
        }
        commit(SET_TRANSACTION_ID, payload);
    },
    resetTransactionId({ commit }) {
        commit(SET_TRANSACTION_ID, '');
    },

    // for no auth 狀態使用
    clearAll({ commit, dispatch }, { page, link }) {
        getLogout();
        commit(SET_AUTH, 'N');
        commit(SET_USER_INFO, {});
        dispatch('resetTransactionId');
        dispatch('services/resetService', null, { root: true });
        dispatch('policy/resetPolicy', null, { root: true });
        // 轉跳登出成功或是沒有權限
        if (!link) {
            page = page || routeName.NO_AUTH;
            router.push({ name: page });
        } else {
            window.location = link;
        }
    },
    setCallBackParam({ commit }, payload) {
        commit(SET_CALL_BACK_PARAM, payload);
    },
};
